import { render } from "./TrazabilidadDM.vue?vue&type=template&id=6e82e9d6&scoped=true"
import script from "./TrazabilidadDM.vue?vue&type=script&lang=js"
export * from "./TrazabilidadDM.vue?vue&type=script&lang=js"

import "./TrazabilidadDM.vue?vue&type=style&index=0&id=6e82e9d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e82e9d6"]])

export default __exports__